
import Initial from "@/components/Qualification/Initial.vue"
import Approved from "@/components/Qualification/Approved.vue"
import Process from "@/components/Qualification/Process.vue"
import Rejected from "@/components/Qualification/Rejected.vue"
import { onMounted } from 'vue';
import { useStore } from "vuex"
import router from '@/router'
import { ref } from 'vue'
import { useMutations } from '@/store/helper'
import Spinner from "@/components/layout/Spinner.vue";
export default {
  name: "Qualification",
  components: {
    Initial,
    Process,
    Approved,
    Rejected,
    Spinner
  },
  setup() {
    const store = useStore();
    const stateHabilitacion = ref("");
    var intervalStateTestset: number;
    const { setStateMenu } = useMutations(['setStateMenu']);
    const spinnerView = ref(false);
    setStateMenu(false);
    const urlvd = ref("");

    function goToDashboard() {
      router.push({ name: 'Dashboard' });
    }

    function urlVideo(nombreVideo: string) {
      var params = {
        Token: localStorage.getItem("Tokensin"),
        NombreVideo: nombreVideo,
      };
      store.dispatch('GetUrlVideo', params).then(data => {
        urlvd.value = data.data;
      }).catch(error => {
        console.log(error);
      });
    }

    const changeState = (change: string) => {
      stateHabilitacion.value = change;
      if (change == "Rechazado") {
        closeInterval()
      } else {
        initializeInterval()
      }
    }

    const Download = () => {
      const url = process.env.VUE_APP_Gateway_API + "Empleador/DownloadInstructive?nombre=instructivo01.pdf";
      window.open(url, '_blank');
    }
    function GetStateTestSet() {
      store.dispatch('GetStateTestSet', localStorage.getItem('Tokensin')).then(data => {
        stateHabilitacion.value = data.data;
        closeInterval()
        if (stateHabilitacion.value == "EnProceso" || stateHabilitacion.value == "ErrorTercero") {
          initializeInterval()
        }
        spinnerView.value = false;
      }).catch(error => {
        spinnerView.value = false;
      });
    }
    function closeInterval() {
      window.clearInterval(intervalStateTestset);
    }
    function initializeInterval() {
      intervalStateTestset = window.setInterval(GetStateTestSet, 40000);
    }
    onMounted(() => {
      spinnerView.value = true;
      urlVideo("VideoHabilitacion.mp4");
      GetStateTestSet();
    });

    return {
      goToDashboard,
      stateHabilitacion,
      changeState,
      Download,
      urlvd,
      spinnerView,
    };
  }

};
